import { useState } from 'react';
import Swal from 'sweetalert2';
import styled from 'styled-components';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updateInviteSpouse } from '../../data';
import { Wrapper, Title } from '../../../../shared/ModalComponents';
import { Button } from '../../../../shared/FormStyles/Button';
import {
  ModalButtonGroup,
  SmallLabel,
  TextAreaInput,
} from '../StyledComponents';
import { BaseInput as Input, Label } from '../../../../shared/FormStyles';
import Modal from '../../../../shared/Modal/Modal.jsx';
import { useNotification } from '../../../../shared/Notification/useNotification';

const InputWrapper = styled.div`
  margin: 0 0 16px;
  width: 100%;

  &:nth-last-child(2) {
    margin: 0 0 24px;
  }
`;

const SpouseForm = ({ onCancel, onConfirm, demo }) => {
  const [subject, setSubject] = useState(demo.dependentBoardEmailSubject || '');
  const [body, setBody] = useState(demo.dependentBoardEmailBody);

  return (
    <Wrapper>
      <Title>Edit Spouse Message</Title>
      <InputWrapper>
        <Label>Subject</Label>
        <Input
          id="spouse_subject"
          type="text"
          onChange={e => setSubject(e.target.value)}
          value={subject}
        />
      </InputWrapper>
      <InputWrapper>
        <Label>Body</Label>
        <TextAreaInput
          rows="5"
          id="spouse_body"
          onChange={e => setBody(e.target.value)}
          value={body}
        />
      </InputWrapper>
      <ModalButtonGroup>
        <Button variant="tertiary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="containedBlue"
          ml="8px"
          type="submit"
          onClick={() => onConfirm({ subject, body })}
        >
          Save
        </Button>
      </ModalButtonGroup>
    </Wrapper>
  );
};

const SpouseButton = ({ demo }) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('shared');
  const { showError } = useNotification();

  const { mutate: manageSpouseMutation } = useMutation(updateInviteSpouse, {
    onSuccess: () => {
      queryClient.invalidateQueries(['editDemo']);
      Swal.close();
    },
    onError: () => {
      showError({ content: t('errorText') });
    },
  });

  const modalForm = () => {
    Modal({
      component: (
        <SpouseForm
          demo={demo}
          onCancel={() => Swal.clickCancel()}
          onConfirm={manageSpouseMutation}
        />
      ),
      width: '394px',
      padding: '24px',
    });
  };

  return (
    <SmallLabel style={{ marginLeft: '10px' }} onClick={modalForm}>
      Edit Spouse Message
    </SmallLabel>
  );
};

export default SpouseButton;
